import { gql } from '@apollo/client';

export default gql`
  query getPaymentStatus($orderId: Float!) {
    orderGetPaymentStatus(id: $orderId) {
      paymentConfirmation
    }
  }
`;